import { render, staticRenderFns } from "./ContenuProfil.vue?vue&type=template&id=35c255bc"
import script from "./ContenuProfil.vue?vue&type=script&lang=js"
export * from "./ContenuProfil.vue?vue&type=script&lang=js"
import style0 from "./ContenuProfil.vue?vue&type=style&index=0&id=35c255bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports